(ns frontend.view.modals.events
  (:require
   [frontend.state.current-session :as current-session]
   [frontend.view.modals.db :as db]
   [potpuri.core :as p]
   [re-frame.core :as rf]))

(def DEBUG_MODALS false)

(defn close-modal!
  [modal-type modal-key]
  (if DEBUG_MODALS
    (swap! db/state assoc-in [modal-key :shown?] false)
    (swap! db/state dissoc modal-key))
  ;; we must deref to sync cursor
  (deref db/state))

(defn close-modals
  [state modals]
  (->> state
       (p/map-vals (fn [v]
                     (if (some #{(:modal-type v)} modals)
                       (assoc v :shown? false)
                       v)))))

(defonce order-atom (atom 0))

(defn open-modal!
  ([modal-type]
   (open-modal! modal-type {}))
  ([modal-type props]
   (let [modal-index (swap! order-atom inc)]
     (when current-session/is-mobile?
       (.scrollTo js/window 0 0))
     (swap! db/state assoc
       modal-index
       {:order        modal-index
        :modal-type   modal-type
        :props        props
        :close-modal! (partial close-modal! modal-type modal-index)
        :shown?       true}))))

(rf/reg-fx
 ::close-modal
 (fn [close-modal!]
   (close-modal!)))

(rf/reg-fx
  ::open-modal
  (fn [open-modal!]
    (open-modal!)))
